<template>
  <div class="mx-4 mb-4">
    <b-form @submit="onSubmit" v-if="payment_transaction && payment_transaction.deposit_layout==1">
      <b-form-group
        :label="$t('transaction_detail_bank_deposit.order_reference')"
        label-for="payment-reference"
      >
        <b-form-input
          id="payment-reference"
          v-model="form.payment_reference"
          required
          class="mb-4"
        ></b-form-input>
      </b-form-group>

      <div class="d-flex">
        <b-form-group
          :label="$t('transaction_detail_bank_deposit.SEC')"
          label-for="SEC"
        >
          <b-form-input
            id="SEC"
            v-model="form.SEC"
            required
            class="mb-4"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          :label="$t('transaction_detail_bank_deposit.sheet')"
          label-for="sheet"
          class="ml-auto"
        >
          <b-form-input
            id="sheet"
            v-model="form.sheet"
            required
            class="mb-4"
          ></b-form-input>
        </b-form-group>
      </div>

      <b-form-group
        :label="$t('transaction_detail_bank_deposit.date')"
        label-for="date"
      >
        <date-picker
          id="deposit-date"
          v-model="form.date"
          required
          :config="dateOptions"
          class="mb-4"
        ></date-picker>
      </b-form-group>

      <b-button
        type="submit"
        variant="primary-b"
        class="submit-btn mx-auto mt-5 w-75"
      >
        {{ $t("transaction_detail_bank_deposit.confirm") }}
      </b-button>
    </b-form>

    <b-form @submit="onSubmit" v-if="payment_transaction && payment_transaction.deposit_layout==2">
      <b-form-group
        :label="$t('transaction_detail_bank_deposit.order_reference')"
        label-for="payment-reference"
      >
        <b-form-input
          id="payment-reference"
          v-model="form.payment_reference"
          required
          class="mb-4"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        :label="$t('transaction_detail_bank_deposit.remitter')"
        label-for="remitter"
      >
        <b-form-input
          id="remitter"
          v-model="form.remitter"
          required
          class="mb-4"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        :label="$t('transaction_detail_bank_deposit.amount')"
        label-for="amount"
        class="ml-auto"
      >
        <b-form-input
          id="amount"
          v-model="form.amount"
          required
          class="mb-4"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        :label="$t('transaction_detail_bank_deposit.date')"
        label-for="date"
      >
        <date-picker
          id="deposit-date"
          v-model="form.date"
          required
          :config="dateOptions"
          class="mb-4"
        ></date-picker>
      </b-form-group>

      <b-button
        type="submit"
        variant="primary-b"
        class="submit-btn mx-auto mt-5 w-75"
      >
        {{ $t("transaction_detail_bank_deposit.confirm") }}
      </b-button>
    </b-form>

  </div>
</template>


<script>
export default {
  name: "transaction-detail-bank-deposit",
  props: {
    payment_transaction: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      form: {
        payment_reference: "",
        SEC: "",
        sheet: "",
        date: "",
        remitter: "",
        amount: "",
      },
      dateOptions: {
        format: "YYYY-MM-DD",
      },
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.$emit("input", Object.assign({}, this.form));
      this.resetForm();
    },
    resetForm() {
      this.form.payment_reference = "";
      this.form.SEC = "";
      this.form.sheet = "";
      this.form.date = "";
      this.remitter = "";
      this.amount = "";
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        transaction_detail_bank_deposit: {
          order_reference: "Order reference",
          SEC: "SEC",
          sheet: "Sheet",
          date: "Date",
          confirm: "Confirm",
          remitter: "Remitter / Account Name",
          amount: "Remittance Amount",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.title {
  font-size: $font-size-medium * 1.1;
  font-weight: bold;
}

.submit-btn {
  font-size: $font-size-medium !important;
  font-weight: bold !important;
}
</style>
